<template>
  <div v-loading="loading" class="lead-detail">
    <div v-if="!showEmpty">
      <fragment v-for="(group, index) in groupInfo" :key="index">
        <QS-h4-title :title="group.title" no-decorate>
          <template slot="content">
            <el-tag
              v-if="group.title === '线索信息' && group.platformTag"
              size="medium" type="danger">
              {{ group.platformTag }}
            </el-tag>
          </template>
        </QS-h4-title>
        <QS-column-box
          :source="group.source"
          :column="4"
          :list="group.items"
          separator=":"
          v-if="group.groupRenderType === 'row-col'"
          labelWidth="100"
        >
          <template slot="edit" slot-scope="item">
            <el-popover trigger="click" placement="top" v-model="editPopoverVisible">
              <div>
                <el-form :inline="true" :model="form" :rules="rules" ref="nameForm" class="demo-form-inline" size="small">
                  <el-form-item label="" prop="userName">
                    <el-input v-model="form.userName" placeholder="请输入内容"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button size="mini" type="text" @click="closeEditNamePopover">取消</el-button>
                    <el-button type="text" size="mini" @click="handleSaveBtnClick('nameForm')" :loading="saveNameLoading">保存</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="edit-name" slot="reference">
                <span>{{ item.value || '-' }}</span>
                <el-button isIcon icon="QS-icon-feedback" type="text" @click="handleEditIconBtnClick(item.value)" />
              </div>
            </el-popover>
          </template>
          <template slot="tag" slot-scope="item">
            <LeadTag :tags="item.value" v-if="item.value && item.value.length" />
            <span v-if="!item.value || !item.value.length"> - </span>
          </template>
          <template slot="goodsId" slot-scope="item">
            <span v-if="item.value" class="a-hover-link" @click="handleGoodDetail(item.value)">{{item.value}}</span>
            <span v-else>{{ item.value || '-' }}</span>
          </template>
          <template slot="orderId" slot-scope="item">
            <router-link v-if="item.value" :to="`/workbench/rentOrder/detail?id=${item.value}&orderType=personal`">{{item.value}}</router-link>
            <span v-else>-</span>
          </template>
        </QS-column-box>
        <QS-common-table
          v-if="group.groupRenderType === 'table'"
          :data="group.list"
          :columns="group.columns"
          :pagination="false">
          <template slot="col-followRemarks" slot-scope="col">
            {{ col.row.followRemarks || '--' }}
          </template>
        </QS-common-table>
      </fragment>
    </div>
    <el-empty :image-size="200" v-if="showEmpty"></el-empty>
    <DetailDrawer ref="detailDrawerRef"  />
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { getSalesLeadDetail, resetSalesLeadName } from '@/api/domain/orders'
import { getGroupInfo, getLeadTagConfig, fieldRenderTypeMap } from './config'
import LeadTag from '@/pages/orders/salesLeadManagement/components/leadTag.vue'
import DetailDrawer from '@/pages/shop/commodity/detailDrawer/index.vue'

export default {
  components: {
    LeadTag,
    DetailDrawer,
  },
  data() {
    return {
      groupInfo: null,
      leadConfig: null,
      editPopoverVisible: false,
      loading: true,
      showEmpty: false,
      saveNameLoading: false,
      form: {
        userName: '',
      },
      rules: {
        userName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 64, message: '长度在 2 到 64 个字符', trigger: 'blur' },
        ],
      },
    }
  },
  created() {
    this.handleInit()
  },
  methods: {
    handleGoodDetail(id) {
      this.$refs.detailDrawerRef?.open({
        id,
      })
    },
    handleInit() {
      const { id } = this.$route.query
      this.loading = true
      getSalesLeadDetail({ id })
        .then((res) => {
          if (res.code === 1) {
            this.groupInfo = getGroupInfo(res.data)
            this.leadConfig = getLeadTagConfig(res.data)
            this.showEmpty = false
          } else {
            throw new Error(`销售线索详情接口--code:${res.code}`)
          }
        })
        .catch(() => {
          this.groupInfo = null
          this.leadConfig = null
          this.showEmpty = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    closeEditNamePopover() {
      this.editPopoverVisible = false
    },
    handleEditIconBtnClick(val) {
      this.form.userName = val
    },
    handleSaveBtnClick(formName) {
      this.$refs[formName][0].validate((valid) => {
        if (valid) {
          const { id } = this.$route.query
          this.saveNameLoading = true
          resetSalesLeadName({
            id,
            name: this.form.userName,
          })
            .then((res) => {
              if (res.code === 1) {
                this.groupInfo[0].items.forEach((item) => {
                  if (item.key === fieldRenderTypeMap.get('name')) {
                    item.value = this.form.userName
                  }
                })
                this.$message.success('保存成功')
              } else {
                if (!res.msg) {
                  this.$message.error('保存失败，请重试')
                }
                throw new Error(`销售线索修改姓名--code:${res.code}`)
              }
            })
            .catch(() => {
              console.error('保存失败，请重试')
            })
            .finally(() => {
              this.saveNameLoading = false
              this.closeEditNamePopover()
            })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.edit-name {
  display: inline-flex;
}

.edit-input {
  width: 150px;
  margin-right: 10px;
}

.lead-detail {
  height: 100%;
}
</style>
